const TableCell = ({ children, className = '', ...props }) => {
  const classes = ['common-table__cell', className].filter(Boolean).join(' ');

  return (
    <td className={classes} {...props}>
      {children}
    </td>
  );
};

export default TableCell;
